import { useQuery } from "@tanstack/react-query";

import { SearchData, SortData } from "#modules/quoteRequestLines/fetchQuoteRequestLines.api";
import { quoteRequestLinesQuery } from "#modules/quoteRequestLines/quoteRequestLinesQuery";
import { useDebounce } from "#shared/helpers/useDebounce";
import { useQueryParams } from "#shared/helpers/useQueryParams";

export const useQuoteRequestLines = (search?: SearchData, sort?: SortData) => {
  const queryParams = useQueryParams();
  const page = parseInt(queryParams.get("page") ?? "1");

  const debounceDelay = 300; // 300ms
  const [searchParams] = useDebounce([search], debounceDelay);

  const { data, ...rest } = useQuery({
    ...quoteRequestLinesQuery(page, searchParams, sort),
  });

  return {
    quoteRequestLines: data?.quoteRequestLines ?? [],
    quoteRequestLinesCount: data?.quoteRequestLinesCount ?? 0,
    allQuoteRequestLinesCount: data?.allQuoteRequestLinesCount ?? 0,
    quoteRequestLinesCountPerPage: data?.quoteRequestLinesCountPerPage ?? 0,
    ...rest,
  };
};
